import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=0b54ed77&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./privacy.vue?vue&type=style&index=0&id=0b54ed77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54ed77",
  null
  
)

export default component.exports